import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "submitButton", "validatable" ]

  errorSources = new Map()

  validatableTargetDisconnected(element) {
    if (this.errorSources.delete(element)) {
      this.updateSubmitButtons()
    }
  }

  handleValidationChange(event) {
    this.recordSpeakerErrorState(event.target, event.detail.hasError)
    this.updateSubmitButtons()
  }

  recordSpeakerErrorState(source, hasError) {
    if (hasError) {
      this.errorSources.set(source, true)
    } else {
      this.errorSources.delete(source)
    }
  }

  updateSubmitButtons() {
    const hasErrors = this.errorSources.size > 0
    this.submitButtonTargets.forEach(button => {
      button.disabled = hasErrors
    })
  }
}
